import { and, asc, desc, eq } from "drizzle-orm";
import {
  ingredient,
  type PowerSyncDrizzleDB,
  recipe_item,
  stock_movement,
} from "@comandero/powersync";
import {
  liveIngredientFilters,
  liveRecipeItemFilters,
  liveStockMovementFilters,
} from "../live/filters";

/** Ingredientes de la org (con stock), ordenados por nombre. */
export function getIngredientsQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(ingredient)
    .where(and(eq(ingredient.organization_id, organizationId), ...liveIngredientFilters()))
    .orderBy(asc(ingredient.name));
}

/** BOM de un producto: ingredientes que consume y en qué cantidad. */
export function getRecipeItemsQuery(db: PowerSyncDrizzleDB, productId: string) {
  return db
    .select()
    .from(recipe_item)
    .where(and(eq(recipe_item.product_id, productId), ...liveRecipeItemFilters()));
}

/** Todas las recetas de la org (para resolver consumo de una orden). */
export function getAllRecipeItemsQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(recipe_item)
    .where(and(eq(recipe_item.organization_id, organizationId), ...liveRecipeItemFilters()));
}

/** Movimientos de stock de un ingrediente (auditoría del saldo derivado). */
export function getStockMovementsQuery(db: PowerSyncDrizzleDB, ingredientId: string) {
  return db
    .select()
    .from(stock_movement)
    .where(and(eq(stock_movement.ingredient_id, ingredientId), ...liveStockMovementFilters()))
    .orderBy(desc(stock_movement.created_at));
}
